import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";
import HeaderNavComponenet from "../component/HeaderNavComponenet";

const Images = () => {
  const [galleryFiles, setGalleryFiles] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [openMenuGallery, setOpenMenuGallery] = useState("");
  const [closeMenuGallery,setCloseMenuGallery] = useState("");

  const [openGallery, setOpenGallery] = useState("In House Competition");

  useEffect(() => {
    const q = query(collection(db, "galleryUpload"), orderBy("date","desc"));
    onSnapshot(q, (querySnapshot) => {
      let galleryArray = [];
      querySnapshot.forEach((doc) => {
        galleryArray.push({ id: doc.id, ...doc.data() });
      });
      setGalleryFiles(galleryArray);
    });
  }, []);

  const handleButton = () => {
    setOpenMenu(!openMenu);
  };

  let tempArr=[]
  tempArr = galleryFiles?.filter((item) => item?.category === openGallery );

  return (
    <React.Fragment>
 

 <HeaderNavComponenet />

      <div className="">
        <div className="py-7 text-center bg-[#162238]">
          <span className="text-4xl font-bold uppercase text-white">
            Session 2023-2024
          </span>
        </div>
        <div className="py-20  bg-[#162238]"></div>
        <div className="bg-white shadow-lg min-h-screen rounded-t-lg lg:p-10 p-2  lg:pr-24 lg:pl-24 ml-5 mr-5 lg:mr-24 lg:ml-24 -lg:mt-40 -mt-40">
          <div className="flex justify-between w-full bg-[#053375] rounded-md">
            <div className="text-xl font-bold text-left px-10 text-white uppercase py-2">
              Explore Gallery
            </div>
            <div className="mt-2.5 justify-items-end">
              <button onClick={handleButton}>
                <img
                  src="../assets/menu.png"
                  alt="pic"
                  className="h-6 w-8 mr-2"
                />
              </button>
            </div>
          </div>

          {openMenu && (
            <div className="bg-slate-100 -pt-2 ">
              <div className="lg:grid lg:grid-cols-2 pb-5">
                <div className="flex  w-full h-20 mt-4  mr-2 ml-2 rounded-lg">
                  <div className="rounded-t-lg ml-10">
                    <img
                      src="../assets/notice-icon.png"
                      alt="pic"
                      className=" w-20 h-20"
                    />
                  </div>
                  <div className="text-center ml-5 hover:cursor-pointer" onClick={() => {
                    setOpenGallery("In House Competition");
                  }}
                  style={{ color: openGallery === "In House Competition" ? "blue" : "black" }}>
                    <h1 className="text-xl">In House Competition</h1>
                  </div>
                </div>
                <div className="flex  w-full h-20 mt-4  mr-2 ml-2 rounded-lg">
                  <div className="rounded-t-lg ml-10">
                    <img
                      src="../assets/notice-icon.png"
                      alt="pic"
                      className=" w-20 h-20"
                    />
                  </div>
                  <div className="text-center ml-5 hover:cursor-pointer" onClick={() => {
                    setOpenGallery("Ethics Club");
                  }}
                  style={{ color: openGallery === "Ethics Club" ? "blue" : "black" }}>
                    <h1 className="text-xl">
                      Ethics Club
                    </h1>
                  </div>
                </div>
                <div className="flex  w-full h-20 mt-4  mr-2 ml-2 rounded-lg">
                  <div className="rounded-t-lg ml-10">
                    <img
                      src="../assets/notice-icon.png"
                      alt="pic"
                      className=" w-20 h-20"
                    />
                  </div>
                  <div className="text-center ml-5 hover:cursor-pointer" onClick={() => {
                    setOpenGallery("Projects");
                  }}
                  style={{ color: openGallery === "Projects" ? "blue" : "black" }}>
                    <h1 className="text-xl">
                      Projects 
                    </h1>
                  </div>
                </div>
                <div className="flex  w-full h-20 mt-4  mr-2 ml-2 rounded-lg">
                  <div className="rounded-t-lg ml-10">
                    <img
                      src="../assets/notice-icon.png"
                      alt="pic"
                      className=" w-20 h-20"
                    />
                  </div>
                  <div className="text-center ml-5 hover:cursor-pointer" onClick={() => {
                    setOpenGallery("Culture Activity");
                  }}
                  style={{ color: openGallery === "Culture Activity" ? "blue" : "black" }}>
                    <h1 className="text-xl">
                       Cultural Activities
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          )}
             {openGallery === "In House Competition" ? (
          <div className="text-lg font-bold text-center lg:p-3 mt-4">
            <div className="lg:grid lg:grid-cols-4 grid pr-2">
              {tempArr.map((item) => (
                <div
                  key={item.pictureUrl}
                  className=" bg-[#FFFFFF]  mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 "
                >
                  <div className=" h-full w-full" >
                    <div  style={{cursor: "pointer"}}  onClick={() =>
                        setOpenMenuGallery(() => {
                          setCloseMenuGallery(false);
                          setOpenMenuGallery(true);
                        })
                      }>
                    <img 
                      src={item.pictureUrl}
                      alt="pic"
                      className="object-cover lg:h-40  w-full"
                    />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
             ) : openGallery === "Ethics Club" ? (
              <div className="text-lg font-bold text-center lg:p-3 mt-4">
                    <div className="lg:grid lg:grid-cols-4 grid pr-2">
              {tempArr.map((item) => (
                <div
                  key={item.pictureUrl}
                  className=" bg-[#FFFFFF]  mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 "
                >
                  <div className=" h-full w-full" >
                    <div  style={{cursor: "pointer"}}  onClick={() =>
                        setOpenMenuGallery(() => {
                          setCloseMenuGallery(false);
                          setOpenMenuGallery(true);
                        })
                      }>
                    <img 
                      src={item.pictureUrl}
                      alt="pic"
                      className="object-cover lg:h-40  w-full"
                    />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            </div>
             ) : openGallery === "Projects" ? (
              <div className="text-lg font-bold text-center lg:p-3 mt-4">
                    <div className="lg:grid lg:grid-cols-4 grid pr-2">
              {tempArr.map((item) => (
                <div
                  key={item.pictureUrl}
                  className=" bg-[#FFFFFF]  mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 "
                >
                  <div className=" h-full w-full" >
                    <div  style={{cursor: "pointer"}}  onClick={() =>
                        setOpenMenuGallery(() => {
                          setCloseMenuGallery(false);
                          setOpenMenuGallery(true);
                        })
                      }>
                    <img 
                      src={item.pictureUrl}
                      alt="pic"
                      className="object-cover lg:h-40  w-full"
                    />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            </div>
             ) :  (
              <div className="text-lg font-bold text-center lg:p-3 mt-4">
                    <div className="lg:grid lg:grid-cols-4 grid pr-2">
              {tempArr.map((item) => (
                <div
                  key={item.pictureUrl}
                  className=" bg-[#FFFFFF]  mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 "
                >
                  <div className=" h-full w-full" >
                    <div  style={{cursor: "pointer"}}  onClick={() =>
                        setOpenMenuGallery(() => {
                          setCloseMenuGallery(false);
                          setOpenMenuGallery(true);
                        })
                      }>
                    <img 
                      src={item.pictureUrl}
                      alt="pic"
                      className="object-cover lg:h-40  w-full"
                    />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            </div>
             )
             }
        </div>
      </div>

     { openMenuGallery && ( <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
        <div className="fixed z-0  justify-center inset-0 overflow-y-auto ">
          <div className=" bg-white rounded-md  min-h-screen w-full">
            <div className="place-self-center rounded-lg  ">
              <div className="flex justify-end">
                <button
                  className=""
                  onClick={() =>
                    setOpenMenuGallery(() => {
                      setCloseMenuGallery(true);
                      setOpenMenuGallery(false);
                    })
                  }
                >
                  <img
                    src="../assets/close-button.png"
                    alt="pic"
                    className="h-10 w-10"
                  />
                </button>
              </div>
            </div>
            <div className="h-full w-full ">
              <Swiper
                loop={true}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className=""
                >
                {tempArr.map((elem,index) => (             
                  <SwiperSlide  key={index}>
                  <img
                    alt="pic"
                    src={elem.pictureUrl}
                    className=" object-contain lg:h-[36rem] h-[30rem] w-full select-none"
                  />
                </SwiperSlide>         
               ))}
              </Swiper>
              {/* <Swiper
         onSwiper={setThumbsSwiper}
         loop={true}
         spaceBetween={10}
         slidesPerView={10}
         freeMode={true}
         watchSlidesProgress={true}
         modules={[FreeMode, Navigation, Thumbs]}
         className="h-32 mt-2"
      >
          {galleryFiles?.map((item) => (
                <SwiperSlide>
                  <img
                    alt="pic"
                    src={item.pictureUrl}
                  />
                </SwiperSlide>
               ))} 
      </Swiper> */}
            </div>
          </div>
        </div>
      </div> 
      )}

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Images;
